<template>
  <div>
    <component :is="type" v-if="useCols" class="mr-n2 mr-sm-n3">
      <b-col :class="ac" v-if="beforeShow">
        <TraButton :variant="beforeVariant" :id="id" :suffix="beforeSuffix"
            @click.native="$emit('beforeClick')" :to="beforeTo">
          <span class="text-nowrap"><Icon v-if="beforeIcon!==null" :type="beforeIcon" /> <slot name="before" /></span>
        </TraButton>
      </b-col>
      <b-col :class="ac" v-if="isShownCancel">
        <TraButton variant="secondary" :id="id" suffix="Cnl"
            @click.native="onAction(item, actionTypes.cancel)">
          <span class="text-nowrap"><Icon type="can" /> {{ actionButtonTexts[actionTypes.cancel] }}</span>
        </TraButton>
      </b-col>
      <b-col :class="ac" v-if="isShownReject">
        <TraButton variant="secondary" :id="id" suffix="Rej"
            @click.native="onAction(item, actionTypes.reject)">
          <span class="text-nowrap"><Icon type="rej" /> {{ actionButtonTexts[actionTypes.reject] }}</span>
        </TraButton>
      </b-col>
      <b-col :class="ac" v-if="isShownSubmit">
        <TraButton variant="secondary" :id="id" suffix="Sub"
            @click.native="onAction(item, actionTypes.submit)">
          <span class="text-nowrap"><Icon type="sub" /> {{ actionButtonTexts[actionTypes.submit] }}</span>
        </TraButton>
      </b-col>
      <b-col :class="ac" v-if="afterShow">
        <TraButton :variant="afterVariant" :id="id" :suffix="afterSuffix"
            @click.native="$emit('afterClick')" :to="afterTo">
          <span class="text-nowrap"><Icon v-if="afterIcon!==null" :type="afterIcon" /> <slot name="after" /></span>
        </TraButton>
      </b-col>
    </component>

    <component :is="isDd?`b-dropdown`:`b-btn-group`" v-else-if="isShown"
        :vertical="isDd?false:vertical" text="" :right="isDd?true:undefined">
      <component :is="isDd?`b-dropdown-item`:`TraButton`" v-if="beforeShow" :variant="beforeVariant" :id="id" :suffix="beforeSuffix"
          @click.native="$emit('beforeClick')" :to="beforeTo">
        <span class="text-nowrap"><Icon v-if="beforeIcon!==null&&(isXs||isMd)" :type="beforeIcon" :isButton="!isDd" :isNav="isDd" /> <slot name="before" /></span>
      </component>
      <component :is="isDd?`b-dropdown-item`:`TraButton`" variant="secondary" :id="id" suffix="Cnl"
          @click.native="onAction(item, actionTypes.cancel)"
          v-if="isShownCancel">
        <span class="text-nowrap"><Icon v-if="isXs||isMd" type="can" :isButton="!isDd" :isNav="isDd" /> {{ actionButtonTexts[actionTypes.cancel] }}</span>
      </component>
      <component :is="isDd?`b-dropdown-item`:`TraButton`" variant="secondary" :id="id" suffix="Rej"
          @click.native="onAction(item, actionTypes.reject)"
          v-if="isShownReject">
        <span class="text-nowrap"><Icon v-if="isXs||isMd" type="rej" :isButton="!isDd" :isNav="isDd" /> {{ actionButtonTexts[actionTypes.reject] }}</span>
      </component>
      <component :is="isDd?`b-dropdown-item`:`TraButton`" variant="secondary" :id="id" suffix="Sub"
          @click.native="onAction(item, actionTypes.submit)"
          v-if="isShownSubmit">
        <span class="text-nowrap"><Icon v-if="isXs||isMd" type="sub" :isButton="!isDd" :isNav="isDd" /> {{ actionButtonTexts[actionTypes.submit] }}</span>
      </component>
      <component :is="isDd?`b-dropdown-item`:`TraButton`" v-if="afterShow" :variant="afterVariant" :id="id" :suffix="afterSuffix"
          @click.native="$emit('afterClick')" :to="afterTo">
        <span class="text-nowrap"><Icon v-if="afterIcon!==null&&(isXs||isMd)" :type="afterIcon" :isButton="!isDd" :isNav="isDd" /> <slot name="after" /></span>
      </component>
    </component>

    <ModalYesNoGeneric :id="`traBtnAct` + suffix + id" :title="modalHeaderText"
        :btnTextReset="$t('btn.a')" btnIconReset="a"
        :btnTextSubmit="modalBtnText" :btnIconSubmit="modalBtnIcon" btnVariantSubmit="secondary"
        @reset="onClose()" @submit="onConfirmation()" />
    <ModalTransPay v-if="isUser && showSubmitModal" @submit="onConfirmation()" @reset="onClose()" id="resTraPay"
        :item="item" />
  </div>
</template>

<script>
import Icon from '@/components/Icon';
import { utcToZonedTime } from 'date-fns-tz';
import { REST } from '@/components/RestCall';
import TraButton from '@/components/transactions/Button';
import ModalYesNoGeneric from '@/components/ModalYesNoGeneric';


const lactionTypes = {
  none:   0,
  submit: 1,
  cancel: 2,
  reject: 4,
}

const lActionCommands = {
  0: ['NONE', ''],
  1: ['SUBMIT', 'sub'],
  2: ['CANCEL', 'can'],
  4: ['REJECT', 'rej'],
}

export default {
  data() {
    return {
      ac: {
        'col-auto': true,
        'mr-2': true,
        'mr-sm-3': true,
        'px-0': true
      },
      actionTypes: lactionTypes,
      // actionButtonTexts: lActionButtonTexts,

      aType: lactionTypes.none,
      modalHeaderText: '',
      modalBtnText: null,
      modalBtnIcon: null,
      showSubmitModal: false,
    }
  },
  computed: {
    actionButtonTexts() {
      return {
        0: '',
        1: this.$t('btn.sub'),
        2: this.$t('btn.can'),
        4: this.$t('btn.rej'),
      };
    },
    // hasBefore() {
    //   return !!this.$slots.before || !!this.$scopedSlots.before;
    // },
    // hasAfter() {
    //   return !!this.$slots.after || !!this.$scopedSlots.after;
    // },
    isUser() {
      return this.$store.state.oLogin.isUser;
    },
    btnType() {
      return this.isDd ? 'b-dropdown-item' : 'b-button';
    },
    isShown() {
      return this.beforeShow || this.isShownCancel || this.isShownReject || this.afterShow;
    },
    isShownCancel() {
      return !this.isUser && this.showCancel && ['PREPARED'].includes(this.item.state);
    },
    isShownReject() {
      return this.isUser && this.showReject && ['PREPARED'].includes(this.item.state);
    },
    isShownSubmit() {
      return this.isUser && this.showSubmit && ['PREPARED'].includes(this.item.state);
    },
    tz() {
      return this.$store.state.settings.timezone;
    },
    isXs() {
      return this.$store.getters.isXs;
    },
    isMd() {
      return this.$store.getters.isMd || this.$store.getters.isLg;
    },
  },
  methods: {
    onClose() {
      this.aType = this.actionTypes.none;
      this.showSubmitModal = false;
    },
    onAction(item, type) {
      if (type === this.actionTypes.submit) {
        this.showSubmitModal = true;
      } else {
        this.aType = type;
        this.modalHeaderText = this.$t('tra.et', [this.$d(utcToZonedTime(item.createdAt+'Z', this.tz),'as')]);
        this.modalBtnText = this.actionButtonTexts[type];
        this.modalBtnIcon = lActionCommands[this.aType][1];
        this.$bvModal.show('traBtnAct' + this.suffix + this.id);
      }
    },
    onConfirmation() {
      let p = null;
      switch (this.aType) {
        case this.actionTypes.submit:
          // action is done by modal itself
          this.showSubmitModal = false;
          break;
        case this.actionTypes.cancel:
        case this.actionTypes.reject:
          p = REST.patch('/transactions/' + this.item.uuid4, { uuid4: this.item.uuid4, action: lActionCommands[this.aType][0] });
          break;
        default:
          this.$store.commit('showWarn',this.$t('dial.anos'));
          break;
      }
      
      if (p != null) {
        p.then(resp => {
            this.$store.commit('showSuccess', resp.d.message);
            if (this.saveResult) {
              this.$store.commit('setTraDetails', resp.d.data);
            }
            this.$emit('success');
          }).catch(e => {
            this.$store.commit('showWarn', e.message);
          }).finally(() => {
            this.onClose();
          })
      } else {
        this.onClose();
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'b-form-row'
    },
    useCols: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    isDd: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      required: true
    },
    suffix: {
      type: String,
      default: ''
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    showReject: {
      type: Boolean,
      default: false
    },
    showSubmit: {
      type: Boolean,
      default: false
    },
    saveResult: {
      type: Boolean,
      default: false
    },
    beforeShow: {
      type: Boolean,
      default: false
    },
    beforeVariant: {
      type: String,
      default: 'primary'
    },
    beforeTo: {
      type: [String, Object],
      default: null
    },
    beforeSuffix: {
      type: String,
      default: 'bSfx'
    },
    beforeIcon: {
      type: String,
      default: null,
    },
    afterShow: {
      type: Boolean,
      default: false
    },
    afterVariant: {
      type: String,
      default: 'primary'
    },
    afterTo: {
      type: [String, Object],
      default: null
    },
    afterSuffix: {
      type: String,
      default: 'aSfx'
    },
    afterIcon: {
      type: String,
      default: null,
    },
  },
  components: {
    TraButton,
    ModalYesNoGeneric,
    Icon,
    ModalTransPay: () => import('@/components/transactions/ModalTransPay'),
  },
}
</script>
